export const DOSAGE_TEMPLATE_NAME_MAX_LENGTH = 100;
